import React from 'react';
import useEventProductList from './useEventProductList';
import Table from '../../../../../../../../components/table/Table';
import { productReactTableColumns } from '../../../../../common/columns';
import { useTableOption } from '../../../../../../../../hooks/common/useTableOption';
import useClientTableList from '../../../../../../../../hooks/common/useClientTableList';
import Modal from '../../../../../../../../components/Modal';
import { ProductItemV2 } from '../../../../../../../../types/product';
import { ColumnUtilType } from '../../../../../../../../types/common/table';
import { WidgetProductFilterOption } from '../../../../../../../../types/widget';

interface EventProductListModalProps {
  eventId: number;
  onClose: () => void;
}

const EventProductListModal = (props: EventProductListModalProps) => {
  const { eventId, onClose } = props;
  const productList = useEventProductList(eventId);
  const { pagination, changeOption } = useTableOption();
  const { list } = useClientTableList({
    list: productList as (ProductItemV2 & Record<string, unknown>)[],
    option: { pagination },
    changeOption,
  });

  return (
    <Modal title="기획전 상품" isOpen={true} width={1000} height={600} isFooter={true} onOk={onClose} onClose={onClose}>
      <Table
        data={list}
        columns={(utils: ColumnUtilType<ProductItemV2, WidgetProductFilterOption>) =>
          productReactTableColumns(utils).map((column) => {
            const { filterable, sortable, ...rest } = column;
            return rest;
          })
        }
        isStriped={true}
        emptyText="기획전 아이템 리스트가 없습니다."
        showPagination={true}
        pagination={{ ...pagination, pages: Math.ceil(productList.length / pagination.pageSize) }}
        getList={changeOption}
      />
    </Modal>
  );
};

export default EventProductListModal;
